/**
 * @ngdoc provider
 * @name CommonUtils.config
 * @description
 * Allows saving and retrieving of configuration data of website
 */
export default function ($windowProvider) {
    'ngInject';
    /**
     * Application config
     * @type {object}
     * @default
     */
    this.data = {
        resultsPath: '/results',
        assetsURL: $windowProvider.$get().assetsURL
    };

    /**
     * Getter for data
     */
    this.getData = () => this.data;

    /**
     * Returns config property
     * @param {number} key
     */
    this.get = (key) => {
        const data = this.getData();

        if (!data.hasOwnProperty(key)) {
            return false;
        }

        return data[key];
    };

    /**
     * Returns instance of config
     * @returns {CommonUtils.config}
     */
    this.$get = () => this;
}



// WEBPACK FOOTER //
// ./src/js/services/config.js